import { RegexConstants } from '@/constants/regex';

export function ableToColorize(value: string | null | undefined): boolean {
    return isCssColorKeywordFill(value) || isHexColorFill(value) || isRgbOrRgbaFunctionFill(value);
}

export function isCssColorKeywordFill(value: string | null | undefined): boolean {
    if (!value) return false;
    const v = value.trim().toLowerCase();
    if (v === 'none' || v === 'transparent' || v === 'currentcolor' || v === 'inherit') return false;
    if (v.startsWith('#') || v.includes('(')) return false;

    const tester = document.createElement('div');
    tester.style.color = '';
    tester.style.color = value;
    return tester.style.color !== '';
}

export function isHexColorFill(value: string | null | undefined): boolean {
    if (!value) return false;
    const v = value.trim();
    return /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(v);
}

export function isRgbOrRgbaFunctionFill(value: string | null | undefined): boolean {
    if (!value) return false;
    const trimmedValue = value.trim();
    const m = trimmedValue.match(RegexConstants.RGB_OR_RGBA_FUNCTION_FILL);
    if (!m) return false;

    const [r, g, b, a] = m.slice(1, 5);

    const validRgb = [r, g, b].every((tok) => {
        if (!tok) return false;
        if (tok.endsWith('%')) {
            const num = Number(tok.slice(0, -1));
            return Number.isFinite(num) && num >= 0 && num <= 100;
        } else {
            const num = Number(tok);
            return Number.isInteger(num) && num >= 0 && num <= 255;
        }
    });
    if (!validRgb) return false;

    if (a !== undefined) {
        if (a.endsWith('%')) {
            const num = Number(a.slice(0, -1));
            return Number.isFinite(num) && num >= 0 && num <= 100;
        } else {
            const num = Number(a);
            return Number.isFinite(num) && num >= 0 && num <= 1;
        }
    }

    return true;
}
